import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1edb2e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-box" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-3" }, " Esims ", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 2 }

import AppTable from "@/components/Table/ts/AppTable.vue";
import {ComputedRef} from "~~/vue";
import {
  ITableBodyRow,
  ITableHeadCell
} from "@/components/Table/ts/interfaces/TableStructure";
import {computed, onMounted, PropType, ref, Ref} from "vue";
import {api} from "@/api/Api";
import {useStore} from "vuex";
import {useBaseTable} from "@/hooks/tables/useTable";
import moment from "moment";
import EditUserEsim from "@/components/ui/Modal/Dialog/instances/EditUserEsim.vue";
import {fetchLocationPackagesDto, ILocationPackage} from "@/api/services/packages/esim/location-packages/types";
import AppButton from "@/components/ui/Buttons/AppButton.vue";
import AddUserEsim from "@/components/ui/Modal/Dialog/instances/AddUserEsim.vue";
import AppPreloader from "@/components/ui/AppPreloader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EsimList',
  props: {
  userId: {
    type: Number as PropType<number>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const plans = ref<ILocationPackage[]>([])
const openedAdd = ref<boolean>(false);
const openedEdit = ref<boolean>(false);
const isPlansLoading = ref<boolean>(true);
const isEsimsLoading = ref<boolean>(true)

function addEsimHandler() {
  openedAdd.value = true
}

onMounted(async () => {
  isPlansLoading.value = true
  const options: fetchLocationPackagesDto = {
    params: {
      perPage: 999,
      filter: "all",
      search: "",
      page: 1
    },
    locationType: "regions"
  }

  try {
    const {data} = await api.fetchLocationPackages(options);
    plans.value = data
    isPlansLoading.value = false
    console.log({data})
  } catch (error) {
    console.log(error);
  }
})

function hide(): void {
  openedEdit.value = false
  openedAdd.value = false
}

const currentEsim = ref<null | number>(null);

const store = useStore();
const esims: Ref = ref([]);



const tableHead: ComputedRef<ITableHeadCell[]> = computed(() => [
  {
    id: "Id",
    label: "ID",
    size: "xxs"
  },
  {
    id: "profileName",
    label: "Profile",
    size: "sm"
  },
  {
    id: "activeTo",
    label: "Active To",
    size: "md"
  },
  {
    id: "installed",
    label: "Installed",
    size: "xs"
  },
  {
    id: "packageName",
    label: "Package",
    size: "sm"
  },
  {
    id: "used",
    label: "Used",
    size: "sm"
  },
  {
    id: "iccid",
    label: "ICCID",
    size: "md"
  },
  {
    id: "activationCode",
    label: "Activation Code",
    size: "md"
  }
]);

const tableRefs = useBaseTable({
  initialViewConfiguration: {page: 1, perPage: 999},
  model: computed(() => esims.value.map((esim: any) => ({...esim}))),
  initialSortOptions: {},
  generateRows(profilesList: any[] = []): ITableBodyRow[] {
    if (!profilesList) {
      return [];
    }

    return profilesList.map(
        (profile): ITableBodyRow => {
          const {id, profileName, activeTo, installed, balance, esim} = profile;
          return {
            onClick: () => {
              openedEdit.value = true;
              currentEsim.value = id;
            },
            cells: [
              {label: esim.id || "-"},
              {label: profileName || "-"},
              {
                label: activeTo
                    ? moment(activeTo).format("D MMM YYYY hh:mm")
                    : "-"
              },
              {label: installed ? "Yes" : "No"},
              {label: profile["package"].title || "-"},
              {label: balance.length ? balance[0]?.used?.split(".")[0] + "MB" : "-"},
              {label: esim.ICCID || '-'},
              {label: esim.ACTIVATION_CODE || '-'}
            ]
          };
        }
    );
  }
});

const rows = computed(() => tableRefs.rows.value);

async function fetchUsersEsims() {
  isEsimsLoading.value = true
  await store.dispatch("setAppLoading", true);

  const {success, message, data} = await api.fetchUsersEsims(props.userId);
  if (!success && message) {
    return await store.dispatch("showErrorNotification", message);
  }
  esims.value = data;
  await store.dispatch("setAppLoading", false);
  isEsimsLoading.value = false
}

fetchUsersEsims();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(AppButton, {
        type: "secondary",
        size: "md",
        onClick: addEsimHandler
      }, {
        default: _withCtx(() => [
          _createTextVNode(" + ")
        ]),
        _: 1
      })
    ]),
    _createVNode(EditUserEsim, {
      opened: openedEdit.value,
      title: 'Edit esim ID: ' + currentEsim.value,
      "profile-id": currentEsim.value,
      "can-cancel": true,
      onHide: hide,
      plans: plans.value,
      plansLoading: isPlansLoading.value,
      "user-id": __props.userId,
      onRefetch: fetchUsersEsims
    }, null, 8, ["opened", "title", "profile-id", "plans", "plansLoading", "user-id"]),
    _createVNode(AddUserEsim, {
      opened: openedAdd.value,
      title: "Add esim",
      "can-cancel": true,
      onHide: hide,
      plans: plans.value,
      plansLoading: isPlansLoading.value,
      "user-id": __props.userId,
      onRefetch: fetchUsersEsims
    }, null, 8, ["opened", "plans", "plansLoading", "user-id"]),
    (isEsimsLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(AppPreloader)
        ]))
      : (_unref(rows).length)
        ? (_openBlock(), _createBlock(AppTable, {
            key: 1,
            "table-head": _unref(tableHead),
            "table-body": _unref(rows),
            "with-footer": false
          }, null, 8, ["table-head", "table-body"]))
        : (_openBlock(), _createElementBlock("h2", _hoisted_5, " No esims "))
  ]))
}
}

})